import 'core-js/features/array/find';
import 'core-js/features/array/from';
import 'core-js/features/array/includes';
import 'core-js/features/map';
import 'core-js/features/promise';
import 'core-js/features/set';
import 'core-js/features/weak-map';
import 'raf/polyfill';

// import * as Sentry from '@sentry/browser';

import { updateReducers } from '@common/react/configureStore';
import { bootClient, renderApp } from '@common/react/loadable/boot-client';

import { User } from '@app/objects/User';
import { baseRoutes, routes } from '@app/routes';
import { ApplicationState, reducers } from '@app/store';

bootClient<User, ApplicationState>(baseRoutes, reducers);

// Allow Hot Module Replacement
if (module.hot) {
	module.hot.accept('./routes', () => {
		renderApp((require('@app/routes') as any).routes);
	});
}

// Enable Webpack hot module replacement for reducers
if (module.hot) {
	module.hot.accept('./store', () => {
		const nextRootReducer = require('@app/store');
		updateReducers((nextRootReducer as any).reducers);
	});
}

// Sentry.init({ dsn: 'https://17d6810f7c5049218134e958d240364d@o977114.ingest.sentry.io/5933541' });
